.vs-carousel-controls {
  position: relative !important;
  width: 100vw;
  height: auto;
}